import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';

import { App } from './App.js';
import { theme } from './theme.js';
import './styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('expected #root element in index.html');

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </StrictMode>,
);
